import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import QrEventTable from "./component/QrEventTable";
import ParticipantTable from "./component/QrEventParticipantsTable";
import QrEventAttendanceBoard from "./component/QrEventAttendanceBoard";

// MUI
import { Box, Paper, Tabs, Tab, Typography } from "@mui/material";

import { ds } from "../../../styles/designSystem";

function TabPanel({ value, index, children }) {
    if (value !== index) return null;
    return <Box>{children}</Box>;
}

// 탭 순서 = URL 의 ?tab= 값
const TAB_KEYS = ["events", "participants", "attendance"];

export default function QrEventAdminListPage() {
    const history = useHistory();
    const location = useLocation();
    const [tab, setTab] = useState(0); // 0: 행사관리, 1: 참가자관리, 2: 입출입(부스) 확인

    // ✅ 참가자 관리·입출입 확인 탭이 함께 쓰는 행사명 — 한 탭에서 고르면 다른 탭도 그 행사로 열린다
    const [selectedEventName, setSelectedEventName] = useState("");

    useEffect(() => {
        const index = TAB_KEYS.indexOf(new URLSearchParams(location.search).get("tab"));
        setTab(index > 0 ? index : 0);
    }, [location.search]);

    const goTab = (index) => {
        setTab(index);
        history.replace(`/qr-event-admin-list?tab=${TAB_KEYS[index]}`);
    };

    const handleChange = (_, newValue) => {
        if (!TAB_KEYS[newValue]) return;
        goTab(newValue);
    };

    // ✅ 행사관리에서 "참가자 관리" 눌렀을 때
    const goParticipants = (eventName) => {
        setSelectedEventName(eventName);
        goTab(1);
    };

    return (
        <Box sx={{ maxWidth: 1600, mx: "auto", px: 3, py: 3 }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2.5 }}>
                <Box>
                    <Typography sx={ds.typography.pageTitle}>
                        LED 포토존 행사 &amp; 참가자 관리
                    </Typography>
                    <Typography sx={ds.typography.pageSubtitle}>
                        행사(등록, 수정, 삭제) + 행사별 참가자 관리와 구역(부스) 입출입 확인을 진행합니다
                    </Typography>
                </Box>
                <Box sx={{ flex: 1 }} />
            </Box>

            <Paper sx={{ ...ds.card, mb: 3 }}>
                <Tabs
                    value={tab}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={ds.components.tabs.root}
                >
                    <Tab label="행사 관리" value={0} />
                    <Tab label="참가자 관리" value={1} />
                    <Tab label="입출입(부스) 확인" value={2} />
                </Tabs>
            </Paper>

            <TabPanel value={tab} index={0}>
                <QrEventTable
                    key="event-table"
                    onGoParticipants={goParticipants}   // ✅ 여기 연결
                />
            </TabPanel>

            <TabPanel value={tab} index={1}>
                <ParticipantTable
                    key="participant-table"
                    selectedEventFromParent={selectedEventName}            // ✅ 자동 선택
                    onSelectedEventChange={(name) => setSelectedEventName(name)} // ✅ 드롭다운 변경 시 동기화
                />
            </TabPanel>

            <TabPanel value={tab} index={2}>
                <QrEventAttendanceBoard
                    key="attendance-board"
                    selectedEventFromParent={selectedEventName}
                    onSelectedEventChange={(name) => setSelectedEventName(name)}
                />
            </TabPanel>
        </Box>
    );
}
